export const BASE_YEARS: Array<number> = [
  2023, 2022, 2021, 2020, 2019, 2018, 2017, 2016,
];
export const FREE_TIER_BASE_YEAR = 2017;
